import axios from "axios";
import { IPagedResult } from "../../../../../models/IPagedResult";
export const ALERTS_URL = `${process.env.REACT_APP_API_URL}/alerts`;

export const alertServices = {
  getNonDismissedAlerts: (queryParams: any) => {
    return axios.get<IPagedResult>(
      `${ALERTS_URL}/nondismissed?pageNumber=${queryParams.pageNumber}&pageSize=${queryParams.pageSize}`
    );
  },
  hasAnyAlert() {
    return axios.get(`${ALERTS_URL}/has-any-alert`);
  },
  dismissAlert: (alertId: number) => {
    return axios.put(`${ALERTS_URL}/dismiss/${alertId}`);
  },
  dismissAllAlerts: () => {
    return axios.put(`${ALERTS_URL}/dismiss-all`);
  },
};
